<template>
  <div class="bookings">
    <page-header
      title="View Fleet"
      :back="{ path: '/operations/consolidation/' }"
      breadcrumb="Dashboard > Operations > Shipment "
    />

    
        <div class="flex flex-nowrap justify-start gap-4">
          <div :style="{ 'background-color': '#FAFAFD', height: '328px' }"  class="w-1/2 pt-4 container-fluid">
            <h3 class="font-semibold text-xl mb-2">Driver Info</h3>
            <div>
              <div class="flex justify-between items-center gap-2">
                <div class="flex items-center gap-4">
                  <span>
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle opacity="0.3" cx="40" cy="40" r="40" fill="#FFEAC4"/>
                      <path d="M41.1386 19.3936C47.7696 19.3936 52.927 24.6983 52.927 31.182C52.927 36.0447 49.9799 40.1706 45.7066 42.0862C53.3691 43.8545 59.2633 50.0434 60.5895 57.8532C60.8842 60.3582 57.2003 60.9477 56.7582 58.59C55.5794 50.9275 49.0958 45.1807 41.1386 45.1807C33.3288 45.1807 26.8452 50.9275 25.519 58.59C25.2243 60.9477 21.5404 60.3582 21.8351 57.8532C23.1613 50.0434 29.0555 43.8545 36.5706 42.0862C32.4447 40.1706 29.3502 36.0447 29.3502 31.182C29.3502 24.6983 34.655 19.3936 41.1386 19.3936ZM41.1386 23.0774C36.718 23.0774 33.1815 26.7613 33.1815 31.182C33.1815 35.6026 36.718 39.1391 41.1386 39.1391C45.5593 39.1391 49.2431 35.6026 49.2431 31.182C49.2431 26.7613 45.5593 23.0774 41.1386 23.0774Z" fill="#FFA600"/>
                    </svg>
                      
                  </span>
                  <div>
                    <p class="font-semibold">
                      {{
                        consolidations.fleet
                          ? consolidations.fleet.user
                            ? consolidations.fleet.user.firstname + ' ' + consolidations.fleet.user.lastname
                            : "N/A"
                          : "N/A"
                      }}
                    </p>
                    <p>
                      {{
                        consolidations.fleet
                          ? consolidations.fleet.user
                            ? consolidations.fleet.user.mobile_no
                            : "N/A"
                          : "N/A"
                      }}
                    </p>
                    <p>{{ consolidations.fleet ? consolidations.fleet.email : "NA" }}</p>
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <span>
                    <svg
                      width="18"
                      height="17"
                      viewBox="0 0 18 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.6665 0.666016H2.33317C1.4165 0.666016 0.674837 1.41602 0.674837 2.33268L0.666504 15.316C0.666504 16.0577 1.5665 16.4327 2.0915 15.9077L3.99984 13.9993H15.6665C16.5832 13.9993 17.3332 13.2493 17.3332 12.3327V2.33268C17.3332 1.41602 16.5832 0.666016 15.6665 0.666016ZM4.83317 6.49935H13.1665C13.6248 6.49935 13.9998 6.87435 13.9998 7.33268C13.9998 7.79102 13.6248 8.16601 13.1665 8.16601H4.83317C4.37484 8.16601 3.99984 7.79102 3.99984 7.33268C3.99984 6.87435 4.37484 6.49935 4.83317 6.49935ZM9.83317 10.666H4.83317C4.37484 10.666 3.99984 10.291 3.99984 9.83268C3.99984 9.37435 4.37484 8.99935 4.83317 8.99935H9.83317C10.2915 8.99935 10.6665 9.37435 10.6665 9.83268C10.6665 10.291 10.2915 10.666 9.83317 10.666ZM13.1665 5.66602H4.83317C4.37484 5.66602 3.99984 5.29102 3.99984 4.83268C3.99984 4.37435 4.37484 3.99935 4.83317 3.99935H13.1665C13.6248 3.99935 13.9998 4.37435 13.9998 4.83268C13.9998 5.29102 13.6248 5.66602 13.1665 5.66602Z"
                        fill="#10233E"
                      />
                    </svg>
                  </span>
                  Send Message
                </div>
              </div>
              <hr class="my-4" />
              <h3 class="font-semibold text-lg my-2">Vehicle Info</h3>
              <div class="row pl-3 mt-4">
                <div class="col-md-4">
                  <div class="flex gap-4">
                    <span>
                      <svg
                        width="54"
                        height="54"
                        viewBox="0 0 54 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle opacity="0.3" cx="27" cy="27" r="27" fill="#FFEAC4" />
                        <path
                          d="M42.9973 29.5847C42.9926 29.4267 42.942 29.2711 42.8477 29.1385L37.7674 21.9645C37.6001 21.7301 37.3181 21.5882 37.017 21.5882H33.3749H30.1518H30.1506C29.6536 21.5882 29.2496 21.9683 29.2496 22.4373V36.2699C29.2496 36.7374 29.6536 37.1176 30.1518 37.1176H31.9995H32.0001C32.0001 39.2618 33.8469 41 36.1251 41C38.403 41 40.2495 39.2618 40.2501 37.1176H42.0978C42.5952 37.1176 43 36.7374 43 36.2688V29.6091C42.9997 29.6011 42.9979 29.5928 42.9973 29.5847ZM33.3749 29.3529V24.176H36.8543L40.5212 29.3529H33.3749ZM36.1245 39.0588C34.9878 39.0588 34.062 38.1878 34.062 37.1176C34.062 36.0475 34.9878 35.1764 36.1245 35.1764C37.2615 35.1764 38.187 36.0475 38.187 37.1176C38.187 38.1878 37.2615 39.0588 36.1245 39.0588ZM26.6771 19H11.1974C10.536 19 10 19.5044 10 20.127V35.9904C10 36.6126 10.536 37.1174 11.1971 37.1174H14.1244C14.1244 39.2615 15.9712 40.9997 18.2494 40.9997C20.5276 40.9997 22.3744 39.2615 22.3744 37.1174H26.6771C27.3383 37.1174 27.8742 36.6126 27.8742 35.9904V20.1267C27.8745 19.5044 27.3389 19 26.6771 19ZM18.2497 39.0588C17.113 39.0588 16.1872 38.1878 16.1872 37.1176C16.1872 36.0475 17.113 35.1764 18.2497 35.1764C19.3867 35.1764 20.3122 36.0475 20.3122 37.1176C20.3122 38.1878 19.3867 39.0588 18.2497 39.0588Z"
                          fill="#FFA600"
                        />
                      </svg>
                    </span>
                    <div class="mt-2">
                      <p class="text-sm text-lightGrey">Type</p>
                      <p class="font-semibold">
                        {{
                          consolidations.fleet ? consolidations.fleet.vehicletype : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="flex gap-2 mt-2">
                    <div>
                      <p class="text-xs text-lightGrey">Vehicle Registration No.</p>
                      <p class="font-semibold break-words">
                        {{
                          consolidations.fleet ? consolidations.fleet.vinnumber : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 pl-4">
                  <div class="flex gap-2 mt-2">
                    <div>
                      <p class="text-xs text-lightGrey">Loading Capacity (Tonnage)</p>
                      <p class="font-semibold">
                        {{
                          consolidations.fleet
                            ? consolidations.fleet.carriageCapacity
                            : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="w-1/2 flex flex-col gap-2">
            <div :style="{ 'background-color': '#FAFAFD', height: '243px' }" class="pt-4 container-fluid">
              <h3 class="font-semibold text-xl mb-2">Load Assigned</h3>
              <p class="font-semibold text-lg">
                {{ consolidations.shippings ? consolidations.shippings.length : "N/A" }}
              </p>
              <hr class="my-3" />
  
              <div class="flex flex-no-wrap justify-between pt-3">
                <h3 class="font-semibold text-xl mb-2">Truck Capacity (Tonnes)</h3>
                <p v-if="consolidations.fleet">
                  {{ calculateCapacity }}/{{ consolidations.fleet.currentLoadCapacity }}
                  Tons
                </p>
              </div>
              <div class="flex flex-row-reverse h-[17px] mt-3">
                <div
                  :style="{ 'background-color': '#D5F2EA' }"
                  class="w-100 relative z-20 h-6 rounded-r-lg"
                ></div>
                <div
                  :style="{
                    'background-color': '#00C48C',
                    width: consolidations.fleet
                      ? ((calculateCapacity / consolidations.fleet.currentLoadCapacity) *
                          100) +
                        '%'
                      : '0%',
                  }"
                  class="h-6 relative z-10 rounded-l-lg"
                ></div>
              </div>
            </div>
            
            <div :style="{ 'background-color': '#FAFAFD', height: '76px' }" class="pt-3 container-fluid">
              <div class="font-semibold text-xl flex flex-no-wrap justify-between">
                <div>Documents</div>
                <div class="font-semibold text-xl ">
                  2 <span class="text-xs">Files</span>
                </div>
              </div>
            </div>
            
          </div>
        </div>
     

    <div class="table-header mt-16">
      <div class="date-picker flex items-center justify-center w-50">
        <span class="text-sm pr-2">Filter by Routes:</span>
        <el-select
          v-model="selectedShippingServiceId"
          placeholder="Select service route"
          @change="getConsolidation()"
        >
          <el-option label="all" :value="null" />
          <el-option
            v-for="shippingservice in shippingServices"
            :key="shippingservice.id"
            :label="
              shippingservice.takeOffLocation + ' - ' + shippingservice.arrivalLocation
            "
            :value="shippingservice.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="flex items-center">
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50">
            <search-icon />
          </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="query"
          />
        </div>
      </div>
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th class="width-xs">
              <base-checkbox v-model="selectAll" />
            </th>
            <th class="shipping-ref-col width-sm">SHIPPING REF.</th>
            <th>BOOKING CHANNEL</th>
            <th>SHIPPER</th>
            <th class="text-center">CONSIGNEE</th>
            <th class="text-center">PICK UP DATE</th>
            <th>EST. DROP DATE</th>
            <th class="width-md d-flex align-items-center relative">STATUS</th>
            <th class="relative width-xs" tabindex="-1" @blur="isTableFilter = false">
              <span class="cursor-pointer" @click="isTableFilter = !isTableFilter">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
              <div v-if="isTableFilter">
                <table-filter @update-table="updateTableData($event)" />
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="consolidations.shippings.length">
          <tr
            v-for="(booking, index) in consolidations.shippings"
            :key="booking.id"
            class="cursor-pointer"
          >
            <td>
              <base-checkbox v-model="selectedShippingIds" :value="booking.id" />
              <label :for="`booking${index}`" class="check-label"></label>
            </td>
            <td>
              <span>{{ booking.shippingReference }}</span
              ><span>MuleEx</span>
            </td>
            <td>
              {{ booking.shippingservice ? booking.shippingservice.orgName : "--" }}
            </td>
            <td>
              <p>
                {{ booking.shipperlocation ? booking.shipperlocation.contactName : "--" }}
              </p>
              <p class="text-gray-600">
                {{
                  booking.shipperlocation ? booking.shipperlocation.address.name : "--"
                }}
                {{
                  booking.shipperlocation
                    ? booking.shipperlocation.city
                      ? "," + booking.shipperlocation.city
                      : ""
                    : ""
                }}
                {{
                  booking.shipperlocation
                    ? booking.shipperlocation.country
                      ? "," + booking.shipperlocation.country
                      : ""
                    : ""
                }}
              </p>
            </td>
            <td>
              <p>
                {{
                  booking.consigneelocation ? booking.consigneelocation.contactName : "--"
                }}
              </p>
              <p class="text-gray-600">
                {{
                  booking.consigneelocation
                    ? booking.consigneelocation.address.name
                    : "--"
                }}
                {{
                  booking.consigneelocation
                    ? booking.consigneelocation.city
                      ? "," + booking.consigneelocation.city
                      : ""
                    : ""
                }}
                {{
                  booking.consigneelocation
                    ? booking.consigneelocation.country
                      ? "," + booking.consigneelocation.country
                      : ""
                    : ""
                }}
              </p>
            </td>

            <td>
              <span>{{
                booking.sourcePickupTime ? booking.sourcePickupTime.split(",")[0] : ""
              }}</span>
              <span>{{
                booking.sourcePickupTime ? booking.sourcePickupTime.split(",")[1] : ""
              }}</span>
            </td>

            <td>
              <span>{{
                booking.sourcePickupTime ? booking.sourcePickupTime.split(",")[0] : ""
              }}</span>
              <span>{{
                booking.sourcePickupTime ? booking.sourcePickupTime.split(",")[1] : ""
              }}</span>
            </td>

            <td>
              <badge :type="'yellow'">{{
                booking.deliveryStatus == "active"
                  ? "Active"
                  : booking.deliveryStatus == "process_handoff"
                  ? "Handed off"
                  : booking.deliveryStatus | capitalize
              }}</badge>
            </td>
            <td class="cursor-pointer relative" @blur="actionRowId = null">
              <el-dropdown>
                <button>
                  <vertical-ellipsis />
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item disabled>ACTIONS</el-dropdown-item>
                  <el-dropdown-item>
                    <button class="flex items-center" @click="viewShipingAction(booking)">
                      <details-icon />
                      <span class="ml-2">View Details</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item hidden>
                    <button class="flex items-center" @click="updateStatus(booking)">
                      <update-icon />
                      <span class="ml-2">Update Status</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item hidden>
                    <button class="flex items-center" @click="editShipingAction(booking)">
                      <return-icon />
                      <span class="ml-2">Edit Shiping Information</span>
                    </button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <button
                      class="flex items-center"
                      @click="removeConsolidation(booking.id)"
                    >
                      <cancel-icon />
                      <span class="ml-2">Un-assign</span>
                    </button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="py-5 bg-white w-100" v-if="isFetchingBookings">
      <loader />
    </div>
    <div
      v-if="false || (!this.consolidations.shippings.length && !isFetchingBookings)"
      class="bg-white w-100 flex justify-center flex-col items-center p-5"
    >
      <empty-table-icon />
      <p class="font-semibold pt-3 pb-5">No Items found!</p>
    </div>
    <pagination-control />

    <update-status-modal2
      @refetchBooking="getConsolidation"
      :booking="selectedEBooking"
      :showmodal="showUpdateStatusModal"
      @close-modal="showUpdateStatusModal = false"
    />
    <edit-booking-modal
      ref="editBooking"
      :show-modal="showEditBookingModal"
      :booking="selectedEBooking"
      @close-modal="showEditBookingModal = false"
    />
    <shipping-label-modal
      ref="showBooking"
      :show-modal="showViewBookingModal"
      :booking="selectedVBooking"
      @close-modal="showViewBookingModal = false"
      :shippingId="selectedVBooking.id"
      :hideNext="true"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/NewPagination";
import TableFilter from "@/components/3pl/Operations/Consolidation/TableFilter";
import EditBookingModal from "@/components/3pl/Operations/Bookings/Modals/EditBookingModal";
import ShippingLabelModal from "@/components/3pl/Operations/Bookings/Modals/ShippingLabelModal";
import UpdateStatusModal2 from "@/components/3pl/Operations/Bookings/Modals/UpdateStatusModal";

export default {
  components: {
    PageHeader,
    PaginationControl,
    TableFilter,
    EditBookingModal,
    ShippingLabelModal,
    UpdateStatusModal2,
  },
  data() {
    return {
      date: "",
      isTableFilter: false,
      removedTableData: [
        "routing",
        "handOff",
        "receiveFrom",
        "deliverTo",
        "distance",
        "weight",
        "income",
        "fleet",
        "driver",
      ],
      bookings: [],
      consolidations: {
        shippings: [],
      },
      showEditBookingModal: false,
      showViewBookingModal: false,
      showUpdateStatusModal: false,
      selectedVBooking: {},
      selectedEBooking: {},
      vehicleType: "",
      vehicleTypes: ["Motorcycle", "Van", "Truck"],
      fleets: [],
      shippingServices: [],
      consolidationRequest: {
        shippingId: [],
        fleetId: null,
      },
      selectedShippingServiceId: null,
      isLoading: false,
      isFetchingBookings: false,
      selectAll: false,
      selectedShippingIds: [],
      selectedFleetId: null,
      query: "",
      docurl: "",
      actionRowId: null,
      isUploadingDoc: false,
      states: [],
      state: "",
    };
  },
  computed: {
    fleet() {
      const ship = localStorage.getItem("fleet");
      return ship ? JSON.parse(ship) : { shipping: [] };
    },
    filterUndispatchedFleet() {
      return this.fleets.filter((f) => f.status != "dispatched");
    },
    unassignedBookings() {
      const unassignedBookings = this.bookings.filter((booking) => {
        return booking.deliveryStatus == "pending";
      });
      return unassignedBookings;
    },
    filteredBookings() {
      return this.filterArray(this.consolidations.shippings, this.query);
    },
    calculateCapacity() {
      let shipmentsBookings = this.consolidations.shippings;

      if (this.consolidations.shippings.length) {
        // this.consolidations.shippings.forEach(x => {

        //   let found = this.unassignedBookings.find(y => y.id == x)
        //   shipmentsBookings.push(found)
        // })

        let initialWeight = 0;
        let allPackages = shipmentsBookings.map((x) => x.packagees);
        let weights = [];
        allPackages.forEach((x) => {
          weights.push(...x.map((y) => y.estimatedWeight * y.quantity ));
        });

        let totalWeightKg = weights.reduce((pre, next) => pre + next, initialWeight);
        let totalWeightTons = totalWeightKg * 0.001;

        return parseFloat(totalWeightTons.toFixed(4));
      } else {
        return 0;
      }
    },
  },
  watch: {
    selectedShippingServiceId(value) {
      if (value == null) {
        this.getAllShippingServices();
      }
    },
    isTableFilter() {
      let container = document.getElementById("table-wrapper");
      container.scrollLeft += 500;
    },
    selectAll(val) {
      if (val) {
        this.bookings.forEach((booking) => {
          this.selectedShippingIds.push(booking.id);
        });
      } else {
        this.selectedShippingIds = [];
      }
    },
  },
  mounted() {
    this.getConsolidation();
    this.getAllBookings();
    this.getAllFleets();
    this.getAllStates();
    this.getAllShippingServices();
  },
  methods: {
    updateStatus(booking) {
      this.selectedEBooking = booking;
      this.showUpdateStatusModal = true;
    },
    editShipingAction(booking) {
      this.selectedEBooking = booking;
      this.showEditBookingModal = true;
    },
    viewShipingAction(booking) {
      this.selectedVBooking = booking;
      this.showViewBookingModal = true;
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    async handleDocUpload(image) {
      this.isUploadingDoc = true;
      try {
        let response = await this.updateDocument(image);
        this.docurl = response;
        this.isUploadingDoc = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingDoc = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
    getCurrentLoadCap(fleet) {
      let calc = (fleet.currentLoadCapacity / fleet.carriageCapacity) * 100;
      let currentLoadCapacity = Number.parseFloat(fleet.currentLoadCapacity);
      return `${calc.toFixed()}% (${currentLoadCapacity.toFixed(2)})`;
    },
    getFleetCalculation(fleet) {
      let calc = (fleet.currentLoadCapacity / fleet.carriageCapacity) * 100;
      let currentLoadCapacity = Number.parseFloat(fleet.currentLoadCapacity);
      return `${calc.toFixed()}% (${currentLoadCapacity.toFixed(2)})`;
    },
    async getAllBookings() {
      this.isFetchingBookings = true;
      try {
        const response = await this.$_getAllBookings(this.selectedShippingServiceId);
        console.log(response);
        this.bookings = response.data.data.allShippings;
      } catch (error) {
        this.handleError(error);
      }
      this.isFetchingBookings = false;
    },
    async getConsolidation() {
      this.isFetchingBookings = true;
      const id = this.$route.params.id;
      try {
        const response = await this.$_getConsolidation(id);
        this.consolidations = response.data.data;
        console.log("consolidation", this.consolidations);
      } catch (error) {
        this.handleError(error);
      }
      this.isFetchingBookings = false;
    },
    async getAllFleets() {
      try {
        const response = await this.$_getAllFleets();
        // console.log(response);
        this.fleets = response.data.data.allFleets;
      } catch (error) {
        this.handleError(error);
        // console.log(error);
      }
    },
    async removeConsolidation(id) {
      this.generateToast("Removing Consolidation...", "info");
      try {
        await this.$_removeConsolidation({
          shipments: [id],
        });
        this.generateToast("Consolidation successfully Removed", "success");
        // console.log(response);
        this.getAllBookings();
        this.getConsolidation();
        this.getAllFleets();
        // this.fleets = response.data.data.allFleets;
      } catch (error) {
        this.handleError(error);
        // console.log(error);
      }
    },
    async getAllShippingServices() {
      try {
        const response = await this.$_getShippingServices();
        // console.log(response);
        this.shippingServices = response.data.data.shippingServices;
      } catch (error) {
        this.handleError(error);
        // console.log(error);
      }
    },
    assignSelectedToFleet() {
      this.selectedShippingIds.forEach((id) => {
        this.assignToFleet(id);
      });
    },
    async assignToFleet(id) {
      this.isLoading = true;
      let payload = {
        fleetId: this.selectedFleetId,
      };
      try {
        await this.$_assignToFleet(id, payload);
        this.generateToast("Consolidation successful", "success");
        // console.log(response);
        this.getAllBookings();
      } catch (error) {
        this.handleError(error);
        // console.log(error);
      }
      this.isLoading = false;
    },
    updateTableData(data) {
      let index = this.removedTableData.indexOf(data);
      if (index >= 0) {
        this.removedTableData.splice(index, 1);
      } else {
        this.removedTableData.push(data);
      }
      this.isTableFilter = false;
      this.scrollLeft();
    },
    scrollLeft() {
      let container = document.getElementById("table-wrapper");
      // console.log(container.scrollLeft);
      container.scrollLeft += 10000;
      // // console.log(container.scrollLeft);
    },
    returnPackageDescription(packageItems) {
      if (!packageItems) return "N.A";
      const packageDescriptions = [];
      packageItems.forEach((item) => {
        packageDescriptions.push(item.description);
      });
      return packageDescriptions.join(", ");
    },
    returnItemsWeights(packageItems) {
      if (!packageItems) return "N.A";
      const packageWeights = [];
      packageItems.forEach((item) => {
        if (item.estimatedWeight) {
          packageWeights.push(item.estimatedWeight);
        }
      });
      const weight = packageWeights.join(", ");
      return weight ? weight : "N.A";
    },
    returnHandlingRequirements(packageItems) {
      if (!packageItems) return "N.A";
      const handlingRequirements = [];
      packageItems.forEach((item) => {
        const itemHandlingRequirements = item.specialHandling
          ? item.specialHandling.join(",")
          : "";
        handlingRequirements.push(itemHandlingRequirements);
      });
      return handlingRequirements.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
#table-wrapper {
  margin: 2rem 0 0;
  overflow-x: auto;
}

.table-wrapper,
.table-wrapper .custom-table {
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
}

/* width */
.table-wrapper::-webkit-scrollbar {
  cursor: pointer;
  width: 5px;
  height: 8px;
}

/* Track */
.table-wrapper::-webkit-scrollbar-track {
  background: #c4c4c4;
}

/* Handle */
.table-wrapper::-webkit-scrollbar-thumb {
  background: #fab427;
  width: 5px;
  border-radius: 20px;
}

.custom-table {
  margin: 0;
}

.booking-categories {
  display: flex;
}

.booking-category {
  color: #383f51;
  opacity: 0.7;
  display: flex;
  align-items: center;
  margin-right: 1rem;

  &.active {
    font-weight: 500;
    opacity: 1;

    .booking-category-amount {
      background: #10233e;
    }
  }

  .booking-category-amount {
    background: #8a97a5;
    border-radius: 10px;
    color: #ffffff;
    margin-left: 1rem;
    padding: 0.25rem 0.75rem;
  }
}

.table-header {
  justify-content: space-between;
}

.booking-categories {
  display: flex;
  align-items: center;
  margin: 2rem 0 4rem 0;
}

th {
  color: rgba(25, 48, 77, 0.7);
  font-weight: 500;
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

th {
  padding: 0.75rem;
  min-width: 10rem;
}

.width-md {
  min-width: 5rem;
}

.width-sm {
  min-width: 8rem;
}

.width-xs {
  min-width: 3rem !important;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 0.75rem;
  vertical-align: top;

  span {
    display: block;
  }

  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.shipping-option-col {
  width: 16%;
}

.shipping-ref-col {
  width: 13%;
}

.booking-status {
  border-radius: 8px;
  padding: 0.5rem;
  font-weight: 500 !important;
  opacity: 1 !important;

  &.cancelled {
    background: #fae5e7;
    color: #d72638 !important;
  }

  &.pending {
    background: #ebfffa;
    color: #09b78a;
  }
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}

.financial-summary {
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 5px;

  .header {
    padding: 0.5rem 2rem;
  }

  width: 25rem;
}

.total-income {
  padding: 1rem 2rem;
}

.gross-income {
  background: var(--primaryblue);
  color: #ffffff;
  padding: 1rem 2rem;
}

.filter {
  background: #f7fafd;
  border-radius: 5px;
  padding: 0.75rem 1rem;
}

.card {
  padding: 2rem 2rem;
}

.input {
  margin-bottom: 1.5rem;
}

.label {
  color: #383f51;
  font-size: 0.9rem;
  font-weight: 600;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 0;
  right: 2rem;
  padding: 0.75rem;
  z-index: 9999;
  font-size: 0.9rem;
  width: 15rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
